<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">

        <div>
            <v-row>
                <v-col cols="12">
                    <div class="grid_stock_in_out_list mb-3">
                        <v-card class="pa-3 grid_card_stock_in_out_list" v-if="$store.state.userProfile.per_materials_add_warehouse == 1">
                            <h3 class="success--text">รับของเข้า</h3>
                            <div class="grid_stock_in_out_list">
                                <v-btn class="child_stock_in_out_list" @click="$router.push('/addlotinpo')" height="100" color="success">
                                    เพิ่มวัตถุดิบ<br />จากใบสั่งซื้อ
                                </v-btn>
                                <v-btn class="child_stock_in_out_list" @click="$router.push('/addlotin')" height="100" color="success">เพิ่มวัตถุดิบเข้าคลัง</v-btn>
                            </div>
                        </v-card>
                        <v-card class="pa-3 grid_card_stock_in_out_list">
                            <h3 class="error--text">เบิกของใช้</h3>
                            <div class="grid_stock_in_out_list">
                                <v-btn class="child_stock_in_out_list" @click="addLotinPage(zone_detail.id)" height="100" color="error" v-for="(zone_detail,index) in zone_list" :key="index">โซน {{ zone_detail.name }}</v-btn>
                            </div>
                        </v-card>
                    </div>
                    <v-btn height="60" width="100%" @click="$router.push('/alllot')" v-if="$store.state.userProfile.per_warehouse_in_out == 1">ดูรายการ เข้า-ออก คลัง</v-btn>
                </v-col>
            </v-row>
        </div>

    </div>
</div>
</template>

<script>
import zoneall from '@/api/stock/stocklist/zoneall.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            zone_list: [],
        }
    },
    methods: {
        async zoneAll() {
            zoneall.zoneList().then((response) => {
                if (response.data.successful === true) {
                    this.zone_list = response.data.zone
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addLotinPage(id) {
            this.loading_page = true
            await zoneall.addZoneWithdraw().catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
            // const idPage = {
            //     id: id,
            // }
            // this.$store.commit('addLotinPage', idPage)
            // this.$router.push('/addlotout')
            await zoneall.addMaterialWithdraw(id).then((response) => {
                if (response.data.successful === true) {
                    const idPage = {
                        id: id,
                    }
                    this.$store.commit('addLotinPage', idPage)
                    this.$router.push('/addlotout')
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        }
    },
    created() {
        zoneall.createMaterialWithdraw().catch((error) => {
            if (error.response.status === 401) {
                this.$store.commit('logOutSuccess')
                this.$router.push('/login')
            }
        })
    },
    mounted() {
        this.zoneAll()
    }
}
</script>

<style scoped>
.cursor_stock_in_out_list {
    cursor: pointer;
}

.grid_stock_in_out_list {
    display: grid;
    grid-template-columns: 50% 50%;
}

.grid_stock_in_out_list>.grid_card_stock_in_out_list:nth-child(odd) {
    margin-right: 4px;
}

.grid_stock_in_out_list>.grid_card_stock_in_out_list:nth-child(even) {
    margin-left: 4px;
}

.grid_stock_in_out_list>.child_stock_in_out_list {
    margin-top: 15px;
}

.grid_stock_in_out_list>.child_stock_in_out_list:nth-child(odd) {
    margin-right: 4px;
}

.grid_stock_in_out_list>.child_stock_in_out_list:nth-child(even) {
    margin-left: 4px;
}

@media only screen and (max-width: 750px) {
    .grid_stock_in_out_list {
        grid-template-columns: 100%;
    }

    .grid_stock_in_out_list>.grid_card_stock_in_out_list:nth-child(odd) {
        margin-right: 0;
    }

    .grid_stock_in_out_list>.grid_card_stock_in_out_list:nth-child(even) {
        margin-left: 0;
    }

    .grid_stock_in_out_list>.child_stock_in_out_list:nth-child(odd) {
        margin-right: 0;
    }

    .grid_stock_in_out_list>.child_stock_in_out_list:nth-child(even) {
        margin-left: 0;
    }
}
</style>
